import styled from 'styled-components';

import {
	Button,
	fontSize,
	FontSizes,
	fontWeight,
	FontWeights,
	minWidth,
	units,
} from '@calm-web/design-system';

export const Description = styled.div`
	margin-top: ${units(1.25)};
`;

export const SubmitButton = styled(Button)`
	width: 100%;
	min-width: 200px;
	margin: ${units(2)} auto;

	${minWidth('tablet')} {
		width: auto;
	}
`;

export const Help = styled.div`
	margin: ${units(1)} auto;
	width: 100%;
	text-align: left;
	${fontSize(FontSizes.sm)}
	${fontWeight(FontWeights.Light)};
`;

export const MarginBanner = styled.div`
	margin-top: ${units(2)};
`;
